"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallStatus = getInstallStatus;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _q = _interopRequireDefault(require("q"));

var _InstallStatusActions = require("ui-addon-scriptloader/installStatus/InstallStatusActions");

var _InstallStatusStore = _interopRequireDefault(require("ui-addon-scriptloader/installStatus/InstallStatusStore"));

var _InstallStatusConstants = require("ui-addon-scriptloader/installStatus/InstallStatusConstants");

var installBoolKey = 'isInstalled';

function createResponse(statusCode) {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, installBoolKey, statusCode === _InstallStatusConstants.INSTALLED), (0, _defineProperty2.default)(_ref, "statusCode", statusCode), _ref;
}

function getInstallStatus() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var useCache = !!opts.useCache;

  var currentStatus = _InstallStatusStore.default.get();

  if (useCache && currentStatus !== _InstallStatusConstants.NOT_INITIALIZED && currentStatus !== _InstallStatusConstants.PENDING) {
    return _q.default.Promise.resolve(createResponse(currentStatus));
  }

  return (0, _InstallStatusActions.fetchInstallStatus)().then(function () {
    var newStatus = _InstallStatusStore.default.get();

    return createResponse(newStatus);
  });
}